import React, { useEffect } from 'react';
import { LAYER_CATEGORY_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useFetchSpatialLayers from '../../hooks/useFetchSpatialLayers';
import { MapLayersControl } from './MapLayersControl';
import { MapLayersControlWithTabs } from './MapLayersControlWithTabs';
import { trackMapLayersControlView } from './mapLayersControlTrackings';
import { useForceOffOldCRGWhenWFSPresent } from './useForceOffOldCRGWhenWFSPresent';
import useMapLayerAnalytics from './useMapLayerAnalytics';

/**
 * Container for Map Layers UI.
 * Starts the spatial-layers fetch, then gates on the layer_category capability
 * to render either the tabbed or flat-list version. The control mounts
 * immediately so GIS and other layers are visible while spatial layers load.
 * Spatial-layer rows appear when that fetch completes.
 *
 * Once layer_category is enabled for all PSAPs, delete
 * MapLayersControl.js and render MapLayersControlWithTabs directly.
 */
const MapLayersControlContainer = () => {
  const isFetched = useFetchSpatialLayers();
  const { hasCapability } = useHasCapability(LAYER_CATEGORY_CAPABILITY);

  useForceOffOldCRGWhenWFSPresent();
  // Track the map lifecycle rather than transient panel rows.
  useMapLayerAnalytics();

  useEffect(() => {
    if (!isFetched) {
      return;
    }
    trackMapLayersControlView({
      layout: hasCapability ? 'tabs' : 'flat',
    });
  }, [isFetched, hasCapability]);

  return hasCapability ? <MapLayersControlWithTabs /> : <MapLayersControl />;
};

export default MapLayersControlContainer;
